import React from 'react';
import { Link } from 'react-router-dom';
import monImage from '../img/1.png';
// Import de la bibliothèque de confettis
import confetti from 'canvas-confetti';

const Home = () => {

  // Fonction pour déclencher les confettis au survol
  const handleHoverConfetti = (e) => {
    const rect = e.target.getBoundingClientRect();
    // On calcule la position relative pour que les confettis partent de l'image
    const x = (rect.left + rect.width / 2) / window.innerWidth;
    const y = (rect.top + rect.height / 2) / window.innerHeight;

    confetti({
      origin: { x, y },
      particleCount: 100,
      spread: 70,
      startVelocity: 40,
      colors: ['#5865F2', '#A855F7', '#ffffff'], // Couleurs Discord & Neon Purple
      zIndex: 9999,
    });
  };

  return (
    <div className="pt-20 overflow-x-hidden">
      
      {/* SECTION 1 : HERO */}
      <section className="w-full">
        <div className="max-w-6xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
          
          {/* TEXTE */}
          <div>
            <h1 className="text-6xl font-black mb-6 leading-tight">
              De la <span className="text-discord-blurple">Robotique</span> au Full Stack.
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
              Je suis passionné par l'informatique et la robotique depuis le collège (merci les cours de techno 😎).
              Mon parcours est aussi varié que ma curiosité. Du <strong>développement Web</strong> aux <strong>systèmes embarqués</strong>, je refuse de me laisser enfermer dans une case.
              ☕
            </p>
            <div className="flex gap-4">
              <Link to="/projets" className="bg-neon-purple text-white px-8 py-4 rounded-3xl font-bold shadow-lg shadow-neon-purple/20 hover:scale-105 transition-transform">
                Voir mes projets
              </Link>
              <a href="https://github.com/JeMeSuisPerdu/JeMeSuisPerdu" target="_blank" rel="noreferrer" className="px-8 py-4 rounded-3xl font-bold border border-gray-200 dark:border-white/10 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                Github
              </a>
            </div>
          </div>
          
          {/* IMAGE AVEC EFFETS (ÉTOILES + CONFETTIS) */}
          <div className="hidden md:flex justify-center items-center relative">
            
            {/* Éléments décoratifs flottants (Emojis) */}
            <div className="absolute -top-10 right-10 text-4xl animate-bounce delay-1000 z-0">✨</div>
            <div className="absolute bottom-0 -left-5 text-5xl animate-pulse z-20">⭐</div>
            <div className="absolute top-1/2 -right-12 text-3xl animate-bounce z-0 opacity-80">🚀</div>
            
            {/* Conteneur Image */}
            <div 
              className="p-10 rounded-[3rem] bg-gradient-to-tr from-discord-blurple/10 to-neon-purple/10 border border-white/10 rotate-3 hover:rotate-0 transition-transform duration-500 cursor-pointer relative z-10 group"
              onMouseEnter={handleHoverConfetti} // Déclenche les confettis ici
            >
              <img 
                src={monImage} 
                alt="Illustration Portfolio" 
                className="w-64 h-auto rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500" 
              />
            </div>
          </div>

        </div>
      </section>

      {/* SECTION 2 : BANNIÈRE INTERMÉDIAIRE */}
      <section className="w-full bg-gray-50 dark:bg-[#0c0c0c] border-y border-gray-100 dark:border-white/5 py-12">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-8 opacity-70">
           <div className="text-center md:text-left font-bold uppercase tracking-tighter text-2xl">
              L3 Conception & Développement <br/> <span className="text-neon-purple">d'Applications (CDA)</span>
           </div>
           <div className="flex gap-8 text-4xl">
              <span className="hover:-translate-y-2 transition-transform duration-300 cursor-default">🐤</span>
              <span className="hover:-translate-y-2 transition-transform duration-300 delay-75 cursor-default">🐥</span>
              <span className="hover:-translate-y-2 transition-transform duration-300 delay-150 cursor-default">🐣</span>
              <span className="hover:-translate-y-2 transition-transform duration-300 delay-200 cursor-default">🥚</span>
           </div>
        </div>
      </section>

      {/* SECTION 3 : PARCOURS */}
      <section className="w-full bg-white dark:bg-[#050505] py-20">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-12 flex items-center gap-4">
            Expériences <span className="h-[2px] flex-1 bg-gray-100 dark:bg-white/5"></span>
          </h2>
          
          <div className="space-y-12">
            {/* 1. Stage 2ème année - MUON (2025) */}
            <div className="relative pl-8 border-l-2 border-neon-purple">
              <div className="absolute -left-[9px] top-0 h-4 w-4 bg-neon-purple rounded-full shadow-[0_0_10px_#A855F7]"></div>
              <span className="text-neon-purple font-bold text-sm uppercase tracking-wider">Janvier — Mars 2025</span>
              <h3 className="text-xl font-bold mt-1">Stage Développeur Full Stack — Agence MUON</h3>
              <p className="text-gray-600 dark:text-gray-400 mt-2 leading-relaxed">
                Développement de <strong>"The Resto"</strong>, une plateforme MERN (MongoDB, Express, React, Node). 
                Mise en place d'un système de réservation en temps réel, JWT et Stripe.
              </p>
            </div>

            {/* 2. Assistant Digital - Crédit Agricole (2024) */}
            <div className="relative pl-8 border-l-2 border-gray-200 dark:border-white/10">
              <div className="absolute -left-[9px] top-0 h-4 w-4 bg-gray-400 rounded-full"></div>
              <span className="opacity-50 font-bold text-sm uppercase tracking-wider">Juillet — Août 2024</span>
              <h3 className="text-xl font-bold mt-1">Assistant Digital — Crédit Agricole (Longuyon)</h3>
              <p className="text-gray-600 dark:text-gray-400 mt-2 leading-relaxed">
                Automatisation de tâches via des <strong>macros VBA (Excel)</strong> et initiation au marketing digital.
              </p>
            </div>

            {/* 3. Stage 1ère année - MUON (2024) */}
            <div className="relative pl-8 border-l-2 border-gray-200 dark:border-white/10">
              <div className="absolute -left-[9px] top-0 h-4 w-4 bg-gray-400 rounded-full"></div>
              <span className="opacity-50 font-bold text-sm uppercase tracking-wider">Mai — Juin 2024</span>
              <h3 className="text-xl font-bold mt-1">Stage Développeur Web — Agence MUON</h3>
              <p className="text-gray-600 dark:text-gray-400 mt-2 leading-relaxed">
                Réalisation d'un site vitrine <strong>WordPress</strong> et optimisation SEO technique.
              </p>
            </div>

            {/* 4. Entrepreneuriat - Algérie (2022-2023) */}
            <div className="relative pl-8 border-l-2 border-gray-200 dark:border-white/10">
              <div className="absolute -left-[9px] top-0 h-4 w-4 bg-gray-400 rounded-full"></div>
              <span className="opacity-50 font-bold text-sm uppercase tracking-wider">2022 — 2023</span>
              <h3 className="text-xl font-bold mt-1">Gestion de Projet Logiciel — Algérie</h3>
              <p className="text-gray-600 dark:text-gray-400 mt-2 leading-relaxed">
                Création d'entreprise et recrutement. Cette expérience a été mon <strong>déclic technique</strong> pour reprendre mes études.
              </p>
            </div>

            {/* 5. Baccalauréat (2022) */}
            <div className="relative pl-8 border-l-2 border-gray-200 dark:border-white/10">
              <div className="absolute -left-[9px] top-0 h-4 w-4 bg-gray-400 rounded-full"></div>
              <span className="opacity-50 font-bold text-sm uppercase tracking-wider">2022</span>
              <h3 className="text-xl font-bold mt-1">Baccalauréat Général — Mention Assez Bien</h3>
              <p className="text-gray-600 dark:text-gray-400 mt-2">
                Spécialités HGGSP (Géopolitique) et SES (Économie).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 : CALL TO ACTION */}
      <section className="w-full bg-discord-blurple/5 py-24 border-t border-gray-50 dark:border-white/5">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-black mb-6">Prêt à collaborer ?</h2>
          <p className="text-gray-500 mb-10">Je suis actuellement en recherche de stage ou de projets stimulant 😏.</p>
          <Link to="/projets" className="bg-discord-blurple text-white px-10 py-5 rounded-full font-bold hover:shadow-xl transition-all">
             Découvrir mes réalisations
          </Link>
        </div>
      </section>

    </div>
  );
};

export default Home;